import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Col, Row , Table} from 'reactstrap';
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DatasourceScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);
        this.state = {
            selectedDatabaseId: this.props.match.params.database_id || null,
            datasource: {
                id: parseInt(this.props.match.params.datasource_id, 10) || '',
                code_name: '',
                description: '',
                name: '',
                databases: [],
            },
            isGrantingPermission: queries.is_granting_permission || false,
            userId: queries.user_id || 0,
            isScanning: false,
        }
    }
    componentWillMount() {
        this.getDatasource();
    }
    componentDidMount = () => {
    }
    deleteDatasource() {
        const { datasource } = this.state;
        this.setState({ isScanning: true });
        api.fetchAPI({
            method: 'delete',
            uri: `datasources`,
            body: datasource,
            success: (response) => {
                if (response.status === 'ok') {
                    alert(`Datasource ${datasource.name} has been deteled`);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
        this.setState({ isScanning: false });
    }
    scanDatasource() {
        const { datasource } = this.state;
        this.setState({ isScanning: true });
        api.fetchAPI({
            method: 'get',
            uri: `datasource/${datasource.id}/scan`,
            success: (response) => {
                if (response.status === 'ok') {
                    alert(`Scan has been started for datasource ${datasource.name}`)
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
        this.setState({ isScanning: false });
    }
    getDatasource() {
        const { datasource, selectedDatabaseId, isGrantingPermission, userId } = this.state;
        let uri = `datasource/${datasource.id}`;

        if (userId && isGrantingPermission) {
            uri = `${uri}?permission_user_id=${userId}`;
        }
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                const datasource = response.datasource;

                // Move the selected field to top of the list
                if (selectedDatabaseId) {
                    let selectedDatabase = null;
                    datasource.databases.map(database => {
                        if (database.id === selectedDatabaseId) {
                            selectedDatabase = database;
                        }
                    })
                    if (selectedDatabase) {
                        datasource.databases = datasource.database.filter(database => database.id !== selectedDatabase.id);
                        datasource.databases.unshift(selectedDatabase);
                    };
                }

                this.setState({ datasource });
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { datasource, selectedDatabaseId, isGrantingPermission, userId, isScanning } = this.state;
        document.title = `${datasource.code_name || datasource.name} | DataDex`;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1 className="main-object-code_name">{datasource.name}</h1>
                        <span className="main-object-type">{datasource.object_type}</span>
                    </Col>
                    <Col xs={12}>
                        <h5 className="main-object-datasource_type">Database type: {datasource.datasource_type}</h5>
                    </Col>
                    <Col xs={12}>
                        <br/>
                        <p>{datasource.description}</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Button tag={Link} to={`/datasource/${datasource.id}/edit`} color="primary">
                                Edit
                            </Button>{' '}
                            <Button color={isScanning ? 'secondary' : 'warning'} onClick={() => this.scanDatasource()} disabled={isScanning}>
                                {isScanning ? 'Scanning datasource...' : 'Scan'}
                            </Button>{' '}
                            <Button color="danger" onClick={() => this.deleteDatasource()}>
                                Delete
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col xs={12}>
                        <p>Databases</p>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th>Database name</th>
                                    <th>Data type</th>
                                    <th>Description</th>
                                    <th>Tag</th>
                                    {isGrantingPermission &&
                                        <th>Allow</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {datasource.databases.map(database =>
                                    <DataRow
                                        isGrantingPermission={isGrantingPermission}
                                        userId={userId}
                                        dataObject={database}
                                        shouldHighlight={parseInt(database.id, 10) === parseInt(selectedDatabaseId, 10)}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Datasource/index.js